import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { useCitation, prepareBody } from '@/utils/citationPanelUtils';
import CitationEntryUnavailable from '@/components/citation-entry-unavailable.vue';
import { useRepositories } from '@/plugins/repositories';
var buildReferencingPublicComments = function buildReferencingPublicComments(publicComments) {
  var comments = publicComments.map(function (publicComment) {
    var citations = !publicComment.contents ? null : publicComment.contents.map(function (content) {
      var sentence = prepareBody(content.content, content.linkText);
      return {
        key: content.key,
        series: content.series,
        sentence: sentence
      };
    });
    var publishedOn = new Date(publicComment.publishedOn).toLocaleDateString('ja-JP-u-ca-japanese', {
      era: 'long'
    });
    var shortTitle = "".concat(publishedOn, "\u4ED8").concat(publicComment.agency, "\u30D1\u30D6\u30B3\u30E1");
    return {
      docId: publicComment.publicCommentId,
      shortTitle: shortTitle,
      title: publicComment.publishedTitle,
      uriByAgency: publicComment.uriByAgency,
      uriOnEGov: publicComment.uriOnEGov,
      commentsAndResponsesUriExternal: publicComment.commentsAndResponsesUriExternal,
      columns: publicComment.columns || [],
      citations: citations,
      packs: publicComment.packs
    };
  });
  return comments;
};
export default defineComponent({
  name: 'CitationPanelPublicComment',
  components: {
    CitationEntryUnavailable: CitationEntryUnavailable
  },
  props: {
    documentId: {
      type: String,
      required: false,
      default: undefined
    },
    sectionKeys: {
      type: Array,
      required: false,
      default: undefined
    },
    selected: {
      type: Boolean,
      required: true
    }
  },
  setup: function setup(props) {
    var repositories = useRepositories();
    var reference = computed(function () {
      return {
        documentId: props.documentId,
        sectionKeys: props.sectionKeys
      };
    });
    var _useCitation = useCitation(reference, {
        fetcher: function () {
          var _fetcher = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(documentId, sectionKeys) {
            var docSections;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  _context.n = 1;
                  return repositories.citations.getCitationPublicComment(documentId, sectionKeys);
                case 1:
                  docSections = _context.v;
                  return _context.a(2, buildReferencingPublicComments(docSections));
              }
            }, _callee);
          }));
          function fetcher(_x, _x2) {
            return _fetcher.apply(this, arguments);
          }
          return fetcher;
        }(),
        prevent: computed(function () {
          return !props.selected;
        })
        // 修正前の状態でこのコンポーネントだけローディング状態を親コンポーネントに emit していなかったのでいったんコメントアウトしておく
        // beforeFetch: () => context.emit('update:loading', true),
        // afterFetch: () => context.emit('update:loading', false),
      }),
      publicComments = _useCitation.list;
    var publicCommentLink = function publicCommentLink(_ref) {
      var uriByAgency = _ref.uriByAgency,
        uriOnEGov = _ref.uriOnEGov,
        commentsAndResponsesUriExternal = _ref.commentsAndResponsesUriExternal;
      if (uriOnEGov) {
        return uriOnEGov;
      } else if (uriByAgency) {
        return uriByAgency;
      } else {
        return commentsAndResponsesUriExternal;
      }
    };
    var cellWidthStyles = function cellWidthStyles(publicComment) {
      var _publicComment$citati;
      var res = {};
      (publicComment.columns || []).forEach(function (col, index) {
        res["--cell-width-".concat(index + 1)] = "".concat(col.weight, "%");
      });
      if (!((_publicComment$citati = publicComment.citations) !== null && _publicComment$citati !== void 0 && _publicComment$citati.length)) {
        res['--citation-height'] = '248px';
      }
      return res;
    };
    return {
      publicComments: publicComments,
      publicCommentLink: publicCommentLink,
      cellWidthStyles: cellWidthStyles
    };
  }
});